import { defaultTo } from "lodash";
import { IModel, ISalesItemOptionModel, Model, SalesItemOptionModel } from "@common/models";

export interface ISalesPlanContentModel extends IModel {
    salesPlanContentId: number;
    salesPlanId: number;
    salesItemOptionId: number;
    sortOrder: number;
    salesItemId: number;
    salesItemName: string;
    salesItemOption: ISalesItemOptionModel;
}

export class SalesPlanContentModel extends Model implements ISalesPlanContentModel {
    salesPlanContentId: number;
    salesPlanId: number;
    salesItemOptionId: number;
    sortOrder: number;
    salesItemId: number;
    salesItemName: string;
    salesItemOption: SalesItemOptionModel;

    constructor(params?: Partial<ISalesPlanContentModel>) {
        super(params);
        this.salesPlanContentId = defaultTo(params?.salesPlanContentId, 0);
        this.salesPlanId = defaultTo(params?.salesPlanId, 0);
        this.salesItemOptionId = defaultTo(params?.salesItemOptionId, 0);
        this.sortOrder = defaultTo(params?.sortOrder, 0);
        this.salesItemId = defaultTo(params?.salesItemId, 0);
        this.salesItemName = defaultTo(params?.salesItemName, "");
        this.salesItemOption = defaultTo(params?.salesItemOption, new SalesItemOptionModel());
    }
}
